/*
  CSS styles loading on demand
*/
document.querySelectorAll("[data-section-css]").forEach((el) => {
  const hrefs = el.dataset.sectionCss.split(",");

  hrefs.forEach((href) => {
    if (document.querySelector(`link[href="${href.trim()}"]`)) return;
    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  });
});

/*
  JS scripts loading on demand
*/
document.querySelectorAll("[data-section-js]").forEach((el) => {
  const srcs = el.dataset.sectionJs.split(",");

  srcs.forEach((src) => {
    if (document.querySelector(`script[src="${src.trim()}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  });
});

/*
  External HTTP links
*/
function decorateHttpsLinks() {
  document.querySelectorAll('a[href*="https://"]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
}
decorateHttpsLinks();

/*
  Media (Video/Iframe/Model) on view
*/
function initMediaOnView() {
  var videos = document.querySelectorAll('video');
  var iframes = document.querySelectorAll('iframe[data-src]');
  var models = document.querySelectorAll('model-viewer[data-src]');
  var mediaItems = [];

  if (!videos.length && !iframes.length && !models.length) {
    return;
  }

  function isDataAutoplayEnabled(video) {
    if (!video.hasAttribute('data-autoplay')) {
      return false;
    }

    if (video.dataset.autoplay === 'false') {
      return false;
    }

    return true;
  }

  function activateVideo(video) {
    if (video.dataset.poster && !video.poster) {
      video.poster = video.dataset.poster;
    }

    if (!isDataAutoplayEnabled(video)) {
      return;
    }

    video.preload = 'auto';
    video.play().catch(function () {
      // Ignore autoplay failures caused by browser policies.
    });
  }

  function activateIframe(iframe) {
    if (iframe.dataset.src && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }
  }

  function activateModel(model) {
    if (model.dataset.src && !model.getAttribute('src')) {
      model.setAttribute('src', model.dataset.src);
    }
  }

  mediaItems = mediaItems.concat(Array.prototype.slice.call(videos));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(iframes));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(models));

  if (!('IntersectionObserver' in window)) {
    mediaItems.forEach((media) => {
      if (media.tagName === 'VIDEO') {
        activateVideo(media);
        return;
      }

      if (media.tagName === 'IFRAME') {
        activateIframe(media);
        return;
      }

      if (media.tagName === 'MODEL-VIEWER') {
        activateModel(media);
      }
    });
    return;
  }

  var observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      if (entry.target.tagName === 'VIDEO') {
        activateVideo(entry.target);
      } else if (entry.target.tagName === 'IFRAME') {
        activateIframe(entry.target);
      } else if (entry.target.tagName === 'MODEL-VIEWER') {
        activateModel(entry.target);
      }
      instance.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '300px 0px 0px 0px'
  });

  mediaItems.forEach((media) => {
    observer.observe(media);
  });
}

initMediaOnView();


/*
  SVG inline utility
*/
async function inlineSvgImages() {
  var root = document;
  var selector = 'img[data-transform-svg-inline]';
  var forceCurrentColor = true;
  var preserveFillNone = true;
  var credentials = 'same-origin';
  var images = [];

  if (!root || typeof root.querySelectorAll !== 'function') {
    return [];
  }

  images = Array.from(root.querySelectorAll(selector));

  return Promise.all(
    images.map(async (img) => {
      var source = img.currentSrc || img.getAttribute('src') || '';
      var normalizedSource = source.split('?')[0].toLowerCase();
      var width = null;
      var height = null;
      var className = null;
      var id = null;
      var style = null;
      var alt = null;
      var response = null;
      var markup = null;
      var svgDocument = null;
      var svg = null;

      if (img.dataset.inlineSvgProcessed === 'true' || !normalizedSource.endsWith('.svg')) {
        return null;
      }

      try {
        response = await fetch(source, { credentials });
        if (!response.ok) {
          return null;
        }

        markup = await response.text();
        svgDocument = new DOMParser().parseFromString(markup, 'image/svg+xml');
        svg = svgDocument.querySelector('svg');
        if (!svg) {
          return null;
        }

        width = img.getAttribute('width');
        height = img.getAttribute('height');
        className = img.getAttribute('class');
        id = img.getAttribute('id');
        style = img.getAttribute('style');
        alt = img.getAttribute('alt');

        if (width) {
          svg.setAttribute('width', width);
        }
        if (height) {
          svg.setAttribute('height', height);
        }
        if (className) {
          svg.setAttribute('class', className);
        }
        if (id) {
          svg.setAttribute('id', id);
        }
        if (style) {
          svg.setAttribute('style', style);
        }

        if (alt) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', alt);
        } else {
          svg.setAttribute('aria-hidden', 'true');
        }

        if (forceCurrentColor) {
          if (svg.hasAttribute('fill')) {
            var svgFillValue = (svg.getAttribute('fill') || '').trim().toLowerCase();
            if (svgFillValue && (!preserveFillNone || svgFillValue !== 'none')) {
              svg.setAttribute('fill', 'currentColor');
            }
          }

          Array.from(svg.querySelectorAll('[fill]')).forEach((element) => {
            var fillValue = (element.getAttribute('fill') || '').trim().toLowerCase();
            if (fillValue && (!preserveFillNone || fillValue !== 'none')) {
              element.setAttribute('fill', 'currentColor');
            }
          });
        }

        img.dataset.inlineSvgProcessed = 'true';
        img.replaceWith(svg);
        return svg;
      } catch (error) {
        console.error('Error inlining SVG:', error);
        return null;
      }
    })
  );
}
inlineSvgImages()
window.addEventListener('shopify:section:load', inlineSvgImages);

/*
  Shopify's money format
*/
window.Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const defaultFormat = window.Shopify.money_format || "${{amount}}";
  const formatString = format || defaultFormat;

  const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
    if (isNaN(number) || number == null) return "0";

    number = (number / 100).toFixed(precision);
    const [integerPart, decimalPart] = number.split(".");
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return decimalPart ? `${formattedInt}${decimal}${decimalPart}` : formattedInt;
  };

  const placeholderMatch = formatString.match(/{{\s*(\w+)\s*}}/);
  if (!placeholderMatch) return cents;

  const placeholder = placeholderMatch[1];
  let value;

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderMatch[0], value);
};

// Resize images
window.Shopify.resizeImage = function (src, size, crop = "") {
  if (src)
    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
          crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
      });
  else
    return "data:image/svg+xml,%3Csvg class='placeholder-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 525.5 525.5'%3E%3Cpath d='M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z'%3E%3C/path%3E%3Cpath d='M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z'%3E%3C/path%3E%3Cpath d='M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z'%3E%3C/path%3E%3C/svg%3E";
};


/*
  Viewport detection
*/
function initViewportEnteredDetection() {
  const observedElements = new Set();
  const viewportOffset = 60;
  let observer = null;
  let observerRootMargin = null;
  let observerUpdateFrame = null;

  const getViewportEnteredElements = (scope = document) => {
    const elements = [];

    if (scope instanceof Element && scope.matches("[data-viewport-entered]")) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements.push(...scope.querySelectorAll("[data-viewport-entered]"));
    }

    return elements;
  };

  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  const isDesignMode = document.documentElement.dataset.designMode === "true";

  const revealViewportEnteredElements = () => {
    getViewportEnteredElements().forEach((el) => {
      el.dataset.viewportEntered = "true";
    });
  };

  if (isDesignMode || reduceMotionQuery.matches) {
    revealViewportEnteredElements();
    return;
  }

  if ("IntersectionObserver" in window) {
    const getStickyAtcHeight = () => {
      const stickyAtc = document.querySelector('sticky-atc');

      if (!stickyAtc) return 0;

      return Math.ceil(stickyAtc.getBoundingClientRect().height || stickyAtc.offsetHeight || 0);
    };

    const getObserverRootMargin = () => {
      return `0px 0px -${viewportOffset + getStickyAtcHeight()}px 0px`;
    };

    const enterViewport = (el) => {
      el.dataset.viewportEntered = "true";
      observedElements.delete(el);
      observer?.unobserve(el);
    };

    const createObserver = () => {
      observerRootMargin = getObserverRootMargin();

      observer = new IntersectionObserver(
        (entries) => {
          const carouselGroups = new Map();

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const carousel = entry.target.closest("theme-carousel");

            if (carousel) {
              if (!carouselGroups.has(carousel)) {
                carouselGroups.set(carousel, []);
              }

              carouselGroups.get(carousel).push(entry.target);
            } else {
              enterViewport(entry.target);
            }
          });

          carouselGroups.forEach((items) => {
            items
              .sort((a, b) => {
                if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING) return 1;

                return -1;
              })
              .forEach((item, index) => {
                item.style.setProperty("--animation-index", index);
                enterViewport(item);
              });
          });
        },
        {
          rootMargin: observerRootMargin,
        }
      );
    };

    const updateObserverRootMargin = () => {
      if (observerUpdateFrame) return;

      observerUpdateFrame = window.requestAnimationFrame(() => {
        observerUpdateFrame = null;

        const nextRootMargin = getObserverRootMargin();
        if (nextRootMargin === observerRootMargin) return;

        const elements = Array.from(observedElements);
        observer?.disconnect();
        createObserver();
        elements.forEach((el) => observer.observe(el));
      });
    };

    createObserver();

    const observeViewportEnteredElements = (scope = document) => {
      getViewportEnteredElements(scope).forEach((el) => {
        if (observedElements.has(el)) return;
        if (el.dataset.animateOnScroll === "false") return;

        observedElements.add(el);
        observer.observe(el);
      });
    };

    window.addEventListener("resize", updateObserverRootMargin);
    document.addEventListener("sticky-atc:height-change", updateObserverRootMargin);

    observeViewportEnteredElements();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          observeViewportEnteredElements(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    getViewportEnteredElements().forEach((el) => {
      if (el.dataset.animateOnScroll === "false") return;

      el.dataset.viewportEntered = "true";
    });
  }
}

initViewportEnteredDetection();

/*
  Theme info
*/
console.info(
  "%Shoshin theme%c v3 %cby ShoshinTheme%c https://www.shoshintheme.com",
  "background:#020617;color:#f9fafb;padding:2px 8px;border-radius:4px;font-weight:700;",
  "font-weight:700;",
  "",
  ""
);
